import { withStyles, VirtualAccount } from 'vopay';
import styles from './BalanceDetails.module.scss';
import { useLockedFeatures } from '@/providers/LockedFeatures.provider';
import { Balance } from '@/hooks/useApi/useAccountBalances';
import BalanceDetailsHeader from './BalanceDetailsHeader';
import BalanceDetailsCard from './BalanceDetailsCard';
import SubAccountDetails from './SubAccountDetails';

const cn = withStyles(styles);

type BalanceDetailsProps = {
  balance: Balance;
  virtualAccount: VirtualAccount | null;
  onSimulateInboundTransfer: (virtualAccountID: string, currency: string) => Promise<void>;
};

export default function BalanceDetails({ balance, virtualAccount, onSimulateInboundTransfer }: BalanceDetailsProps) {
  const { SubAccountPermissions } = useLockedFeatures();

  return (
    <div className={cn('balanceDetails')}>
      <BalanceDetailsHeader
        balance={balance}
        virtualAccount={virtualAccount}
        onSimulateInboundTransfer={onSimulateInboundTransfer}
      />

      <BalanceDetailsCard balance={balance} />

      {!!SubAccountPermissions && <SubAccountDetails balance={balance} />}
    </div>
  );
}
